import { flip, prop, curry, compose, join, reduce, head } from 'ramda';
import devideSourceCapture from './internal/devideSourceCapture.js';
import '../utils/createTimeline.js';
import '../utils/convertAxisListToTiles.js';
import '../utils/convertAxisToTile.js';
import parseCode from '../utils/parseCode.js';
import '../utils/detectDarkTile.js';
import '../utils/detectPiece.js';
import '../utils/detectOpponent.js';
import '../utils/detectMoved.js';
import '../utils/detectEnemyOnTiles.js';
import '../utils/detectTurn.js';
import '../utils/detectContacted.js';
import '../utils/findCode.js';
import '../utils/findCodeByTile.js';
import '../utils/findOpponentKing.js';
import '../utils/getNextFileByIndex.js';
import '../utils/getNextRankByIndex.js';
import '../utils/getPKeyByTile.js';
import getEqualPieces from '../utils/getEqualPieces.js';
import '../utils/getSymmetryTile.js';
import '../utils/getAnimationAxis.js';
import '../utils/getDirection.js';
import '../utils/getTilesDifference.js';
import '../utils/removeDirection.js';
import '../utils/removeCodeByTile.js';
import '../utils/replaceCode.js';
import { Rook, Pawn } from '../presets/terms.js';
import '../presets/rules.js';
import '../utils/validateTile.js';
import '../utils/filterOpponent.js';
import '../utils/computeDistance.js';
import '../utils/pretendTo.js';
import '../utils/transformInto.js';
import '../utils/diffSnapshot.js';
import '../utils/subInBetweenIndexes.js';

var SymbolsMap={capture:"x",check:"+",checkmate:"#",stalemate:"$"},CastlingMap={a:"O-O-O",h:"O-O"},_prop=flip(prop);function parseNotation(e){var a=e.checkData,o=void 0===a?{isCheck:!1,isStalemate:!1,isCheckmate:!1}:a,t=e.from,c=e.to,r=compose(parseCode,join(""))(c),p=r.side,i=r.piece,s=r.tileName,m=i===Pawn,l=1===t.length&&1===c.length,n=2===t.length&&1===c.length,u=2===t.length&&2===c.length,h=o.isCheck?SymbolsMap.check:"",d="";if(h=o.isCheckmate?SymbolsMap.checkmate:h,h=o.isStalemate?SymbolsMap.stalemate:h,l)d="".concat(i).concat(s),m&&(d=s);else if(n){var f=reduce(devideSourceCapture(p),{},t).source,C=i,k=s;m&&(C=f.fileName),d="".concat(C).concat(SymbolsMap.capture).concat(k);}else u&&(d=compose(_prop(CastlingMap),compose(parseCode.prop("fileName"),head,getEqualPieces(Rook)))(t));return "".concat(d).concat(h)}var parseNotation$1 = curry(parseNotation);

export { parseNotation$1 as default };
//# sourceMappingURL=parseNotation.js.map
